import { render, staticRenderFns } from "./AwardBatch.vue?vue&type=template&id=76747740&scoped=true"
import script from "./AwardBatch.vue?vue&type=script&lang=js"
export * from "./AwardBatch.vue?vue&type=script&lang=js"
import style0 from "./AwardBatch.vue?vue&type=style&index=0&id=76747740&prod&lang=css"
import style1 from "./AwardBatch.vue?vue&type=style&index=1&id=76747740&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76747740",
  null
  
)

export default component.exports